import React, { useState } from "react";
import { useBulkConfig } from "../hooks/useBulkConfig";
import BulkResponseModal from "./BulkResponseModal";
import {
    useFetchNotificationsData,
    useFetchNotificationBulkJobDetailsData,
    useNotificationStatusMutation,
} from "../apis/notificationApis";
import { useProfileData } from "../apis/profileApis";
import { fetch3 } from "../commonApis/commonApis";
import toast from "react-hot-toast";

const url = process.env.REACT_APP_BASE_URL;

interface Props {
    isOpen: boolean;
    onClose: () => void;
    bulkJobId: string;
    notification: any;
}

export const BulkResponseHandler: React.FC<Props> = ({
    isOpen,
    onClose,
    bulkJobId,
    notification,
}) => {
    const [page, setPage] = useState<number>(1);
    const limit = 100;

    const { data: bulkData, isFetching } = useFetchNotificationBulkJobDetailsData(bulkJobId, page, limit);
    const { mutate: statusMutate } = useNotificationStatusMutation(notification?.id);
    const { refetch: profileFetch } = useProfileData();
    const { refetch: fetchNotifications } = useFetchNotificationsData(1, "");

    const { failColumns, allColumns, validationMessages } = useBulkConfig(
        notification?.message
    );

    const onDownloadAll = async () => {
        const res = await fetch3(`${url}/api/bulk/jobs/${bulkJobId}?all=true&type=LM`, "get");
        return res?.data?.errors || [];
    };

    const updateStatus = () => {
        if (notification?.id) {
            statusMutate(
                { seen: true },
                {
                    onSuccess: () => {
                        fetchNotifications();
                        profileFetch();
                    },
                    onError: (error: any) => {
                        toast.error(`${error}`);
                    },
                }
            );
        }
    };

    if (!isOpen) return null;

    const totalFailed = bulkData?.failedRows ?? bulkData?.pagination?.total ?? 0;
    const totalPages = bulkData?.pagination?.totalPages ?? Math.ceil(totalFailed / limit) ?? 1;

    return (
        <BulkResponseModal
            onClose={() => {
                onClose();
                updateStatus();
                profileFetch();
                fetchNotifications();
            }}
            data={{
                successfulRows: bulkData?.successfulRows,
                failedRows: totalFailed,
                errors: bulkData?.errors,
            }}
            config={{
                failKey: "errors",
                failColumns,
                allColumns,
                sheetName: "Failed Data",
                downloadFileName: "failed-rows",
                validationMessages,
            }}
            pagination={{
                currentPage: page,
                totalPages: Math.max(1, totalPages),
                totalCount: totalFailed,
                onPageChange: (newPage: number) => setPage(newPage),
                isLoading: isFetching,
            }}
            onDownloadAll={onDownloadAll}
        />
    );
};

